import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";

import { getProposalConfigurations } from "../../../common/constants/clubs-wizard.constants";
import { ICreateProposalForm } from "../../../common/interfaces/proposals.interface";
import ConfigurationItems from "../../ConfigurationItems/ConfigurationItems";
import WizardHeader from "../../CreateClubWizard/WizardHeader/WizardHeader";
import { clubsStore } from "../../../contexts/clubStore";

const ProposalType = () => {
  const { values, setFieldValue } = useFormikContext<ICreateProposalForm>();
  const { treasury, clubBasicInfo, userRole } = clubsStore();
  const [configurationItems, setConfigurationItems] = useState(
    getProposalConfigurations(
      treasury,
      clubBasicInfo.type,
      userRole!,
      clubBasicInfo.roleConfig
    )
  );

  const [activeConfig, setActiveConfig] = useState(
    configurationItems.find((item) =>
      !item.disabled ? item.name === values.proposalType : null
    )
  );

  useEffect(() => {
    if (!!configurationItems.find((item) => !item.disabled)) {
      setFieldValue("areAllDisabled", false);
    } else {
      setFieldValue("areAllDisabled", true);
    }
  }, []);

  const changeSelectedProposalConfigItem = (item) => {
    if (values.areAllDisabled) {
      return;
    }
    setActiveConfig(item);
    setFieldValue("proposalType", item.name);
  };

  return (
    <div className="proposal-type">
      <WizardHeader
        title="Proposal type"
        description="Create a proposal to start your club's activity."
      />
      <ConfigurationItems
        configurationItems={configurationItems}
        activeConfig={activeConfig!}
        changeSelectedConfigItem={changeSelectedProposalConfigItem}
      />
    </div>
  );
};

export default ProposalType;
